module.exports = __webpack_public_path__ + "media/images/official/special_workcation_02-b80efafdd38fe37172100d9829856395.jpg";